import Vue from 'vue'
import Vuex from 'vuex'
import apiCalls from '@/helpers/apiCall'
import api from '@/helpers/api'

Vue.use(Vuex)

const state = {
  totalCheckout: 0,
  checkout: [],
  checkoutLoaded: false,
  checkoutLastFetch: null
}
const mutations = {
  increment(state) {
    state.totalCheckout++
  },
  setTotalCheckout(state, n) {
    state.totalCheckout = n
  },
  addTotalCheckout(state, n) {
    state.totalCheckout += n
  },
  removeFromTotalCheckout(state, n) {
    state.totalCheckout -= n
  },
  decrement(state) {
    state.totalCheckout--
  },
  setCheckout(state, checkoutData) {
    state.checkout = checkoutData
    state.checkoutLoaded = true
    state.checkoutLastFetch = Date.now()
  },
  cleanCart(state) {
    state.checkout = []
  },
  setTotalItemsCheckout() {
    state.totalCheckout = 0
    if (state.checkout && state.checkout[0] != undefined) {
      state.checkout.forEach(product => {
        state.totalCheckout += product.rateplans.length
      })
    }
  }
}

const actions = {
  async getCheckout({ commit, state }, forceRefresh = false) {
    // Cache de 30 segundos - evita chamadas redundantes muito frequentes
    const CACHE_DURATION = 30000
    const now = Date.now()

    if (
      !forceRefresh &&
      state.checkoutLoaded &&
      state.checkoutLastFetch &&
      now - state.checkoutLastFetch < CACHE_DURATION
    ) {
      return Promise.resolve()
    }

    commit('cleanCart')
    return await apiCalls.get(api.CartGetAll, '', '').then(res => {
      commit('setCheckout', res.data.products || [])
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
